import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Eye, EyeOff, Lock, User, LogIn, Loader2 } from "lucide-react";
import { motion } from "framer-motion";
import LogoImg from "../../asset/images/goelectronixB.png";

import { AuthContext } from "../../context/AuthContext";
import LoginLoader from "../../Component/Loader/LoginLoader";


export default function AdminLogin() {
  const [username, setUserName] = useState("admin");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [remember, setRemember] = useState(true);
  const [errors, setErrors] = useState({ user: "", pwd: "" });
  const [submitting, setSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const navigate = useNavigate();
  const { setAuthUser } = useContext(AuthContext);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("authUserData"));
    if (stored) {
      if (stored.role === 1) navigate("/superdashboard", { replace: true });
      else navigate("/dashboard", { replace: true });

    }
  }, []);


  const validate = () => {
    let ok = true;
    let uErr = "";
    let pErr = "";

    // if (!username.trim()) {
    //   uErr = "Enter username";
    //   ok = false;
    // }

    if (!password) {
      pErr = "Enter password";
      ok = false;
    } else if (password.length < 4) {
      pErr = "Minimum 4 digits";
      ok = false;
    }

    setErrors({ user: uErr, pwd: pErr });
    return ok;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);

    try {
      const payload = { username, password };

      const response = await axios.post(
        "${BASE_URL}/common/login",
        payload
      );

            // inside onSubmit()

      if (response.data.status === true && response.data.data) {
        const userData = response.data.data;

        localStorage.setItem("authUserData", JSON.stringify(userData));
        setAuthUser(userData);

        // Redirect based on user type
        // role-based redirect
        if (userData.role === 1) {
          navigate("/superdashboard", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }

      } else {
        alert(response.data.message || "Invalid credentials");
      }
    } catch (err) {
      console.error(err);
      alert("Login failed. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const brandBlue = "#0B5ED7";
  const brandDarkBlue = "#0A3E91";

  return (
    // <div className="relative min-h-screen bg-slate-50 flex items-center justify-center px-3 sm:px-6">
     <>
      {submitting && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <LoginLoader />
        </div>
      )}

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className={`w-full max-w-md transition-all duration-200 ${
          submitting ? "opacity-40 pointer-events-none select-none" : ""
        }`}
      >
        {/* HEADER */}
        <div className="mb-4 text-center">
          {/* <img src={LogoImg} alt="Logo" className="mx-auto h-10 w-auto" /> */}
          <h1
            className="mt-2 text-xl md:text-2xl font-semibold"
            style={{ color: brandDarkBlue }}
          >
            Admin Login
          </h1>
        </div>

        {/* FORM CARD */}
        <div className="rounded-2xl border bg-white shadow-sm p-4 sm:p-6 md:p-7">
          <form onSubmit={onSubmit} className="space-y-3 md:space-y-4">
            {/* USERNAME */}
            <label className="block text-xs md:text-sm font-medium text-slate-600">
              Username
            </label>

            <div
              className={`relative rounded-xl border ${
                errors.user ? "border-red-400" : "border-slate-200"
              } focus-within:border-slate-400`}
            >
              <span className="absolute left-3 top-2.5 text-slate-400">
                <User size={16} />
              </span>

              <input
                // value={username}
                // onChange={(e) => setUserName(e.target.value)}
                placeholder="admin"
                className="w-full rounded-xl pl-9 pr-3 py-2 text-sm md:text-base outline-none"
              />
            </div>

            {errors.user && (
              <p className="text-xs text-red-500">{errors.user}</p>
            )}

            {/* PASSWORD */}
            <label className="block text-xs md:text-sm font-medium text-slate-600">
              Password
            </label>

            <div
              className={`relative rounded-xl border ${
                errors.pwd ? "border-red-400" : "border-slate-200"
              } focus-within:border-slate-400`}
            >
              <span className="absolute left-3 top-2.5 text-slate-400">
                <Lock size={16} />
              </span>

              <input
                type={showPwd ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="•••••••"
                className="w-full rounded-xl pl-9 pr-9 py-2 text-sm md:text-base outline-none"
              />

              <button
                type="button"
                className="absolute right-2 top-2 p-1 rounded-lg text-slate-500 hover:bg-slate-100"
                onClick={() => setShowPwd((s) => !s)}
              >
                {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>

            {errors.pwd && (
              <p className="text-xs text-red-500">{errors.pwd}</p>
            )}

            {/* SIGN IN */}
            <button
              type="submit"
              disabled={submitting}
              className="mt-1 inline-flex w-full items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm md:text-base font-semibold text-white shadow-sm disabled:opacity-70"
              style={{ backgroundColor: brandBlue }}
            >
              {submitting ? (
                <>
                  <Loader2 className="animate-spin" size={16} /> Signing in…
                </>
              ) : (
                <>
                  <LogIn size={16} /> Sign in
                </>
              )}
            </button>
          </form>
        </div>

        {/* <p className="mt-4 text-center text-[11px] md:text-xs text-slate-500">
          © {new Date().getFullYear()} RR Tech
        </p> */}
      </motion.div>
      </>
    // </div>
  );
}
